// import utils from '@/utils';
// import { Spin } from 'antd';
import * as React from 'react';

export interface ILoadingProps {}

export default function Loading(props: { loading?: boolean }) {
  const { loading = false } = props;
  const [showLoading] = React.useState(loading);
  //   utils.loading = (show: boolean | undefined, options: { time?: number } = {}) => {
  //     setShowLoading(!!show);

  //     if (options.time) {
  //       setTimeout(() => {
  //         setShowLoading(false);
  //       }, options.time);
  //     }
  //   };
  //   console.log('>>>>>>>loading>>>>>>>>>', showLoading);
  return (
    <>
      {showLoading ? (
        <div className="fixed top-0 bottom-0 left-0 right-0 z-[9999] bg-white flex flex-col justify-center items-center bg-opacity-60">
          <img src="/images/logo.png" className="wh-[80px] jump" />
          <div className="mt-16 h-[1px] w-16 rounded-full zoom shadow"></div>
        </div>
      ) : (
        ''
      )}
    </>
  );
}
